import Text from 'components/common/Text';

const StrikethroughSkeleton = ({
  className = '',
  strikethroughText = '',
  textDisplayed = '',
  containerClassNames = '',
  textDisplayedClassName = 'text text-secondary',
  ariaLabel = '',
}) => {
  return (
    <Text htmlElement="span" className={containerClassNames}>
      <Text
        htmlElement="span"
        className={`${className} px-2 line-through`}
        aria-label={`Original ${ariaLabel ? `${ariaLabel} ` : ''}${strikethroughText}`}
      >
        {strikethroughText}
      </Text>
      <Text
        htmlElement="span"
        brandStylesOverrides={textDisplayedClassName}
        aria-label={`Discounted ${ariaLabel ? `${ariaLabel} ` : ''}${textDisplayed}`}
      >
        {textDisplayed}
      </Text>
    </Text>
  );
};

StrikethroughSkeleton.propTypes = {
  className: PropTypes.string,
  strikethroughText: PropTypes.string.isRequired,
  textDisplayed: PropTypes.string.isRequired,
  containerClassNames: PropTypes.string,
  textDisplayedClassName: PropTypes.string,
  ariaLabel: PropTypes.string,
};

export default StrikethroughSkeleton;
